import React from "react";
import { ControlLabel, Button, Alert } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import AnnouncementList from "./announcement-list.jsx"
import AddAnnouncement from "./add-announcement.jsx"

export default class ManageAnnouncement extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            title: '',
            yesLabel: '',
            noLabel: '',
            backLabel: '',
            announcements: []
        }

        this.loadViewModel = this.loadViewModel.bind(this);
        this.onAddNewAnnouncement = this.onAddNewAnnouncement.bind(this);
        this.onBack = this.onBack.bind(this);
        this.setAnnouncements = this.setAnnouncements.bind(this);
    }

    componentDidMount() {
        this.loadViewModel();
    }

    loadViewModel() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get("manage-announcement")
            .then(function (res) {
                self.setState({
                    title: res.data.title,
                    yesLabel: res.data.yesLabel, 
                    noLabel: res.data.noLabel,
                    announcements: res.data.announcements,
                    backLabel: res.data.backLabel
                });
                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onAddNewAnnouncement() {
        let self = this;
        window.location = context.root() + '/app/add-announcement/0';
    }

    onBack() {
        let self = this;
        window.location = context.root() + '/app/marketing-admin';
    }

    setAnnouncements(data) {
        this.setState({
            announcements: data
        });
    }

    render() {
        return (
            <div className="container">
                <div className="container-fluid">
                    <div className="row">
                        <h2 className="text-center ap-title">{this.state.title}</h2>
                    </div>
                    <br /><br />
                    <div className="row">
                        <div className="col-md-6 col-lg-6">
                            <Button onClick={this.onAddNewAnnouncement} className="btn-info ap-fullsize" >ADD NEW ANNOUNCEMENT</Button>
                        </div>
                        <div className="col-md-6 col-lg-6">
                            <Button onClick={this.onBack} className="btn-info ap-fullsize">BACK</Button>
                        </div>
                    </div>
                    <br />
                    <AnnouncementList onChange={this.setAnnouncements} announcements={this.state.announcements} noLabel={this.state.noLabel} yesLabel={this.state.yesLabel}></AnnouncementList>
                </div>
            </div>
        );
    }
}